import { LISCase } from "pwapi";

import { pieceCountEnumToLabel } from "shared/utils/blockUtils";
import { procedureEnumToLabel } from "shared/utils/specimenUtils";

import { useAppSelector } from "app/hooks";
import { useSelectedLab } from "hooks/useSelectedLabStation";
import AccessionNumber from "ui/components/AccessionNumber";
import CasePriority from "ui/components/CasePriority";
import SpecimenProtocolTags from "ui/components/SpecimenProtocolTags";
import { labelForBlock } from "util/blockUtils";

const ScannedBlock = ({
  scanned,
}: {
  scanned: {
    block: LISCase["blocks"][0];
    specimen?: LISCase["specimens"][0];
    case: LISCase;
  };
}) => {
  const lab = useSelectedLab();
  const clinic = useAppSelector((state) =>
    scanned.case?.patient?.clinic_id
      ? state.clinics[scanned.case.patient.clinic_id]
      : undefined
  );
  return (
    <>
      <h4>Scanned Block</h4>
      <article className="Object ScannedCase">
        <dl>
          <div>
            <small>
              <code>
                <AccessionNumber accession={scanned.case.accession} />
              </code>
            </small>
            {scanned.block.piece_count && (
              <small>
                <code>
                  PIECES:{" "}
                  <strong>
                    {pieceCountEnumToLabel(scanned.block.piece_count)}
                  </strong>
                </code>
              </small>
            )}
          </div>
        </dl>
        <h2>
          <strong>
            <code>{labelForBlock(scanned.block, scanned.case)}</code>
          </strong>{" "}
          <code>{procedureEnumToLabel(scanned.specimen?.procedure)}</code>
        </h2>
        {(scanned.case?.priority ||
          (clinic?.location?.state === "NY" &&
            lab.settings?.new_york_lis_tag) ||
          scanned.specimen) && (
          <div>
            <CasePriority priorityCase={scanned.case} />
            {lab.settings?.new_york_lis_tag &&
              clinic?.location?.state === "NY" && (
                <div
                  className="Tag Tag--purple"
                  style={{ marginLeft: scanned.case?.priority ? "0.5em" : 0 }}
                >
                  New York
                </div>
              )}
            {scanned.specimen && (
              <SpecimenProtocolTags
                specimen={scanned.specimen}
                specimens={scanned.case.specimens}
              />
            )}
          </div>
        )}

        <hr />
        <p>{scanned.specimen?.gross_description}</p>
      </article>
    </>
  );
};

export default ScannedBlock;
